import { Card, Col, Row, Grid } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { formatNumber } from '../../../../utils/helpers/format.helper';

const { useBreakpoint } = Grid;

const SubscriptionManagementCard = () => {
    const { t } = useTranslation('dashboard');
    const screens = useBreakpoint();
    const { subscriptionManagement: { data } } = useSelector((state: RootState) => state.dashboard);

    const getCardPadding = () => {
        if (screens.xxl || screens.xl) {
            return screens.xxl ? 24 : 16;
        }
        if (screens.lg || screens.md) return 16;
    };

    const basePadding = getCardPadding();
    const rowGutter = screens.xxl ? 24 : screens.xl ? 16 : 24

    return (
        <Row gutter={[rowGutter, rowGutter]} >
            <Col xs={12}>
                <Card bodyStyle={{ padding: basePadding }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('total_water_consumption')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                        }}>
                            {formatNumber(data?.totalConsumption || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col xs={12}>
                <Card bodyStyle={{ padding: basePadding }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('meter_data_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                        }}>
                            {(data?.totalCounters || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>

            <Col xs={12}>
                <Card bodyStyle={{ padding: basePadding }}>
                    <Row>
                        <Col xs={24} className='base-card-title'>
                            {t('anomaly_count')}
                        </Col>
                        <Col xs={24} className='base-card-value' style={{
                            color: '#000',
                        }}>
                            {(data?.anomalyCount || 0)}
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    )
}

export default SubscriptionManagementCard